module.exports = __webpack_public_path__ + "656e1881c43b5fb35adae8cd7d7e233e.svg";